var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.845 10.7429C17.845 10.7143 17.7866 10.6571 17.7866 10.6571L10.333 0.4C10.1284 0.142857 9.80691 0 9.51462 0C9.22232 0 8.84234 0.142857 8.69619 0.4L1.21343 10.6571C1.21343 10.7143 1.15497 10.7143 1.15497 10.7714C-0.423422 13.4286 -0.364963 16.6286 1.21343 19.3143C2.9672 22.2 6.15322 24 9.51462 24C12.876 24 16.062 22.2 17.7866 19.2857C19.365 16.5429 19.4234 13.3429 17.845 10.7429ZM9.31001 20.0571C8.75465 20.0571 8.28698 19.6 8.28698 19.0571C8.28698 18.5143 8.75465 18.0571 9.31001 18.0571C11.2392 18.0571 12.8468 16.5143 12.8468 14.6C12.8468 14.0571 13.3145 13.6 13.8698 13.6C14.4252 13.6 14.8928 14.0571 14.8928 14.6C14.8928 17.6571 12.3791 20.0571 9.31001 20.0571Z",
    fill: "#2E3243"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorDrop);
export default __webpack_public_path__ + "static/media/color-drop.1f200054.svg";
export { ForwardRef as ReactComponent };